import React from 'react';
import ReactDOM from 'react-dom';
import './reset.css';
import Layout from './layout/index';

// let allData = {};

// if (process.env.NODE_ENV === 'development') {
//     allData = {
//         area: require('./mock/area.json'),
//         sumData: require('./mock/sumData.json'),
//         trend: require('./mock/trend.json'),
//         devicetype: 'share',
//         base62Id: '85mhVvWS5i4',
//     };
// } else {
//     allData = window.allData && Object.keys(window.allData).length ? window.allData : {};
// }

/* eslint-disable no-undef */
ReactDOM.render(<Layout content={allData} fontDiff={__fontDiff} />, document.getElementById('root'));
/* eslint-enable no-undef */
